import EntityStore from '#/unified-rfqs/store/entity';
import { getRfqTime, Rfq } from '#/unified-rfqs/entities/rfq';
import { Drfq } from '#/unified-rfqs/entities/drfq/domain';

const MAX_CLOSED_DRFQS = 50;
export default class RfqsStore extends EntityStore<Rfq> {
  constructor() {
    const sortComparer = (rfqA: Rfq, rfqB: Rfq) => {
      return getRfqTime(rfqB) - getRfqTime(rfqA);
    };

    super({ sortComparer });
  }

  setClosedDrfq(drfq: Drfq) {
    this.setOne(drfq); // Add the new drfq

    const drfqs = this.selectAll().filter((rfq) => rfq.type === 'drfq');

    if (drfqs.length > MAX_CLOSED_DRFQS) {
      const drfqsToRemove = drfqs.slice(MAX_CLOSED_DRFQS);

      for (const oldDrfq of drfqsToRemove) {
        this.removeOne(oldDrfq.id, { permanent: true });
      }
    }
  }
}
